export const provinceList: {
  examAreaId: number;
  Classify: number;
  name: string;
  fullName: string;
  OrderIndex: number;
  id: number;
  parentId: number;
}[] = [
  {
    id: 1,
    name: '全国',
    fullName: '全国',
    parentId: 0,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110000,
    name: '北京',
    fullName: '北京',
    parentId: 0,
    Classify: 1,
    OrderIndex: 2,
    examAreaId: 0,
  },
  {
    id: 110101,
    name: '东城',
    fullName: '东城区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110102,
    name: '西城',
    fullName: '西城区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110105,
    name: '朝阳',
    fullName: '朝阳区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110106,
    name: '丰台',
    fullName: '丰台区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110107,
    name: '石景山',
    fullName: '石景山区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110108,
    name: '海淀',
    fullName: '海淀区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110109,
    name: '门头沟',
    fullName: '门头沟区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110111,
    name: '房山',
    fullName: '房山区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110112,
    name: '通州',
    fullName: '通州区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110113,
    name: '顺义',
    fullName: '顺义区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110114,
    name: '昌平',
    fullName: '昌平区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110115,
    name: '大兴',
    fullName: '大兴区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110116,
    name: '怀柔',
    fullName: '怀柔区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110117,
    name: '平谷',
    fullName: '平谷区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110118,
    name: '密云',
    fullName: '密云区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 110119,
    name: '延庆',
    fullName: '延庆区',
    parentId: 110000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120000,
    name: '天津',
    fullName: '天津',
    parentId: 0,
    Classify: 4,
    OrderIndex: 1,
    examAreaId: 0,
  },
  {
    id: 120101,
    name: '和平',
    fullName: '和平区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120102,
    name: '河东',
    fullName: '河东区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120103,
    name: '河西',
    fullName: '河西区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120104,
    name: '南开',
    fullName: '南开区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120105,
    name: '河北',
    fullName: '河北区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120106,
    name: '红桥',
    fullName: '红桥区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120110,
    name: '东丽',
    fullName: '东丽区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120111,
    name: '西青',
    fullName: '西青区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120112,
    name: '津南',
    fullName: '津南区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120113,
    name: '北辰',
    fullName: '北辰区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120114,
    name: '武清',
    fullName: '武清区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120115,
    name: '宝坻',
    fullName: '宝坻区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120116,
    name: '滨海新',
    fullName: '滨海新区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120117,
    name: '宁河',
    fullName: '宁河区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120118,
    name: '静海',
    fullName: '静海区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 120119,
    name: '蓟州',
    fullName: '蓟州区',
    parentId: 120000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130000,
    name: '河北',
    fullName: '河北省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 3,
    examAreaId: 0,
  },
  {
    id: 130100,
    name: '石家庄',
    fullName: '石家庄市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130200,
    name: '唐山',
    fullName: '唐山市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130300,
    name: '秦皇岛',
    fullName: '秦皇岛市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130400,
    name: '邯郸',
    fullName: '邯郸市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130500,
    name: '邢台',
    fullName: '邢台市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130600,
    name: '保定',
    fullName: '保定市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130700,
    name: '张家口',
    fullName: '张家口市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130800,
    name: '承德',
    fullName: '承德市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 130900,
    name: '沧州',
    fullName: '沧州市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 131000,
    name: '廊坊',
    fullName: '廊坊市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 131100,
    name: '衡水',
    fullName: '衡水市',
    parentId: 130000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140000,
    name: '山西',
    fullName: '山西省',
    parentId: 0,
    Classify: 3,
    OrderIndex: 6,
    examAreaId: 0,
  },
  {
    id: 140100,
    name: '太原',
    fullName: '太原市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140200,
    name: '大同',
    fullName: '大同市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140300,
    name: '阳泉',
    fullName: '阳泉市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140400,
    name: '长治',
    fullName: '长治市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140500,
    name: '晋城',
    fullName: '晋城市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140600,
    name: '朔州',
    fullName: '朔州市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140700,
    name: '晋中',
    fullName: '晋中市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140800,
    name: '运城',
    fullName: '运城市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 140900,
    name: '忻州',
    fullName: '忻州市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 141000,
    name: '临汾',
    fullName: '临汾市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 141100,
    name: '吕梁',
    fullName: '吕梁市',
    parentId: 140000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150000,
    name: '内蒙古',
    fullName: '内蒙古自治区',
    parentId: 0,
    Classify: 3,
    OrderIndex: 2,
    examAreaId: 0,
  },
  {
    id: 150100,
    name: '呼和浩特',
    fullName: '呼和浩特市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150200,
    name: '包头',
    fullName: '包头市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150300,
    name: '乌海',
    fullName: '乌海市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150400,
    name: '赤峰',
    fullName: '赤峰市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150500,
    name: '通辽',
    fullName: '通辽市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150600,
    name: '鄂尔多斯',
    fullName: '鄂尔多斯市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150700,
    name: '呼伦贝尔',
    fullName: '呼伦贝尔市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150800,
    name: '巴彦淖尔',
    fullName: '巴彦淖尔市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 150900,
    name: '乌兰察布',
    fullName: '乌兰察布市',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 152200,
    name: '兴安盟',
    fullName: '兴安盟',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 152500,
    name: '锡林郭勒盟',
    fullName: '锡林郭勒盟',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 152900,
    name: '阿拉善盟',
    fullName: '阿拉善盟',
    parentId: 150000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210000,
    name: '辽宁',
    fullName: '辽宁省',
    parentId: 0,
    Classify: 3,
    OrderIndex: 1,
    examAreaId: 0,
  },
  {
    id: 210100,
    name: '沈阳',
    fullName: '沈阳市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210200,
    name: '大连',
    fullName: '大连市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210300,
    name: '鞍山',
    fullName: '鞍山市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210400,
    name: '抚顺',
    fullName: '抚顺市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210500,
    name: '本溪',
    fullName: '本溪市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210600,
    name: '丹东',
    fullName: '丹东市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210700,
    name: '锦州',
    fullName: '锦州市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210800,
    name: '营口',
    fullName: '营口市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 210900,
    name: '阜新',
    fullName: '阜新市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 211000,
    name: '辽阳',
    fullName: '辽阳市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 211100,
    name: '盘锦',
    fullName: '盘锦市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 211200,
    name: '铁岭',
    fullName: '铁岭市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 211300,
    name: '朝阳',
    fullName: '朝阳市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 211400,
    name: '葫芦岛',
    fullName: '葫芦岛市',
    parentId: 210000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220000,
    name: '吉林',
    fullName: '吉林省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 7,
    examAreaId: 0,
  },
  {
    id: 220100,
    name: '长春',
    fullName: '长春市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220200,
    name: '吉林',
    fullName: '吉林市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220300,
    name: '四平',
    fullName: '四平市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220400,
    name: '辽源',
    fullName: '辽源市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220500,
    name: '通化',
    fullName: '通化市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220600,
    name: '白山',
    fullName: '白山市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220700,
    name: '松原',
    fullName: '松原市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 220800,
    name: '白城',
    fullName: '白城市',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 222400,
    name: '延边',
    fullName: '延边朝鲜族自治州',
    parentId: 220000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230000,
    name: '黑龙江',
    fullName: '黑龙江省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 2,
    examAreaId: 0,
  },
  {
    id: 230100,
    name: '哈尔滨',
    fullName: '哈尔滨市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230200,
    name: '齐齐哈尔',
    fullName: '齐齐哈尔市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230300,
    name: '鸡西',
    fullName: '鸡西市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230400,
    name: '鹤岗',
    fullName: '鹤岗市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230500,
    name: '双鸭山',
    fullName: '双鸭山市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230600,
    name: '大庆',
    fullName: '大庆市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230700,
    name: '伊春',
    fullName: '伊春市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230800,
    name: '佳木斯',
    fullName: '佳木斯市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 230900,
    name: '七台河',
    fullName: '七台河市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 231000,
    name: '牡丹江',
    fullName: '牡丹江市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 231100,
    name: '黑河',
    fullName: '黑河市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 231200,
    name: '绥化',
    fullName: '绥化市',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 232700,
    name: '大兴安岭地',
    fullName: '大兴安岭地区',
    parentId: 230000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310000,
    name: '上海',
    fullName: '上海',
    parentId: 0,
    Classify: 3,
    OrderIndex: 8,
    examAreaId: 0,
  },
  {
    id: 310101,
    name: '黄浦',
    fullName: '黄浦区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310104,
    name: '徐汇',
    fullName: '徐汇区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310105,
    name: '长宁',
    fullName: '长宁区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310106,
    name: '静安',
    fullName: '静安区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310107,
    name: '普陀',
    fullName: '普陀区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310109,
    name: '虹口',
    fullName: '虹口区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310110,
    name: '杨浦',
    fullName: '杨浦区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310112,
    name: '闵行',
    fullName: '闵行区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310113,
    name: '宝山',
    fullName: '宝山区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310114,
    name: '嘉定',
    fullName: '嘉定区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310115,
    name: '浦东新',
    fullName: '浦东新区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310116,
    name: '金山',
    fullName: '金山区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310117,
    name: '松江',
    fullName: '松江区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310118,
    name: '青浦',
    fullName: '青浦区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310120,
    name: '奉贤',
    fullName: '奉贤区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 310151,
    name: '崇明',
    fullName: '崇明区',
    parentId: 310000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320000,
    name: '江苏',
    fullName: '江苏省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 8,
    examAreaId: 0,
  },
  {
    id: 320100,
    name: '南京',
    fullName: '南京市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320200,
    name: '无锡',
    fullName: '无锡市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320300,
    name: '徐州',
    fullName: '徐州市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320400,
    name: '常州',
    fullName: '常州市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320500,
    name: '苏州',
    fullName: '苏州市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320600,
    name: '南通',
    fullName: '南通市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320700,
    name: '连云港',
    fullName: '连云港市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320800,
    name: '淮安',
    fullName: '淮安市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 320900,
    name: '盐城',
    fullName: '盐城市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 321000,
    name: '扬州',
    fullName: '扬州市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 321100,
    name: '镇江',
    fullName: '镇江市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 321200,
    name: '泰州',
    fullName: '泰州市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 321300,
    name: '宿迁',
    fullName: '宿迁市',
    parentId: 320000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330000,
    name: '浙江',
    fullName: '浙江省',
    parentId: 0,
    Classify: 4,
    OrderIndex: 5,
    examAreaId: 0,
  },
  {
    id: 330100,
    name: '杭州',
    fullName: '杭州市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330200,
    name: '宁波',
    fullName: '宁波市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330300,
    name: '温州',
    fullName: '温州市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330400,
    name: '嘉兴',
    fullName: '嘉兴市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330500,
    name: '湖州',
    fullName: '湖州市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330600,
    name: '绍兴',
    fullName: '绍兴市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330700,
    name: '金华',
    fullName: '金华市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330800,
    name: '衢州',
    fullName: '衢州市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 330900,
    name: '舟山',
    fullName: '舟山市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 331000,
    name: '台州',
    fullName: '台州市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 331100,
    name: '丽水',
    fullName: '丽水市',
    parentId: 330000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340000,
    name: '安徽',
    fullName: '安徽省',
    parentId: 0,
    Classify: 1,
    OrderIndex: 1,
    examAreaId: 0,
  },
  {
    id: 340100,
    name: '合肥',
    fullName: '合肥市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340200,
    name: '芜湖',
    fullName: '芜湖市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340300,
    name: '蚌埠',
    fullName: '蚌埠市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340400,
    name: '淮南',
    fullName: '淮南市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340500,
    name: '马鞍山',
    fullName: '马鞍山市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340600,
    name: '淮北',
    fullName: '淮北市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340700,
    name: '铜陵',
    fullName: '铜陵市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 340800,
    name: '安庆',
    fullName: '安庆市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341000,
    name: '黄山',
    fullName: '黄山市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341100,
    name: '滁州',
    fullName: '滁州市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341200,
    name: '阜阳',
    fullName: '阜阳市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341300,
    name: '宿州',
    fullName: '宿州市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341500,
    name: '六安',
    fullName: '六安市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341600,
    name: '亳州',
    fullName: '亳州市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341700,
    name: '池州',
    fullName: '池州市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 341800,
    name: '宣城',
    fullName: '宣城市',
    parentId: 340000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350000,
    name: '福建',
    fullName: '福建省',
    parentId: 0,
    Classify: 1,
    OrderIndex: 4,
    examAreaId: 0,
  },
  {
    id: 350100,
    name: '福州',
    fullName: '福州市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350200,
    name: '厦门',
    fullName: '厦门市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350300,
    name: '莆田',
    fullName: '莆田市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350400,
    name: '三明',
    fullName: '三明市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350500,
    name: '泉州',
    fullName: '泉州市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350600,
    name: '漳州',
    fullName: '漳州市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350700,
    name: '南平',
    fullName: '南平市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350800,
    name: '龙岩',
    fullName: '龙岩市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 350900,
    name: '宁德',
    fullName: '宁德市',
    parentId: 350000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360000,
    name: '江西',
    fullName: '江西省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 9,
    examAreaId: 0,
  },
  {
    id: 360100,
    name: '南昌',
    fullName: '南昌市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360200,
    name: '景德镇',
    fullName: '景德镇市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360300,
    name: '萍乡',
    fullName: '萍乡市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360400,
    name: '九江',
    fullName: '九江市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360500,
    name: '新余',
    fullName: '新余市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360600,
    name: '鹰潭',
    fullName: '鹰潭市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360700,
    name: '赣州',
    fullName: '赣州市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360800,
    name: '吉安',
    fullName: '吉安市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 360900,
    name: '宜春',
    fullName: '宜春市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 361000,
    name: '抚州',
    fullName: '抚州市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 361100,
    name: '上饶',
    fullName: '上饶市',
    parentId: 360000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370000,
    name: '山东',
    fullName: '山东省',
    parentId: 0,
    Classify: 3,
    OrderIndex: 5,
    examAreaId: 0,
  },
  {
    id: 370100,
    name: '济南',
    fullName: '济南市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370200,
    name: '青岛',
    fullName: '青岛市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370300,
    name: '淄博',
    fullName: '淄博市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370400,
    name: '枣庄',
    fullName: '枣庄市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370500,
    name: '东营',
    fullName: '东营市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370600,
    name: '烟台',
    fullName: '烟台市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370700,
    name: '潍坊',
    fullName: '潍坊市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370800,
    name: '济宁',
    fullName: '济宁市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 370900,
    name: '泰安',
    fullName: '泰安市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371000,
    name: '威海',
    fullName: '威海市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371100,
    name: '日照',
    fullName: '日照市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371300,
    name: '临沂',
    fullName: '临沂市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371400,
    name: '德州',
    fullName: '德州市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371500,
    name: '聊城',
    fullName: '聊城市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371600,
    name: '滨州',
    fullName: '滨州市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 371700,
    name: '菏泽',
    fullName: '菏泽市',
    parentId: 370000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410000,
    name: '河南',
    fullName: '河南省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 4,
    examAreaId: 0,
  },
  {
    id: 410100,
    name: '郑州',
    fullName: '郑州市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410200,
    name: '开封',
    fullName: '开封市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410300,
    name: '洛阳',
    fullName: '洛阳市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410400,
    name: '平顶山',
    fullName: '平顶山市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410500,
    name: '安阳',
    fullName: '安阳市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410600,
    name: '鹤壁',
    fullName: '鹤壁市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410700,
    name: '新乡',
    fullName: '新乡市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410800,
    name: '焦作',
    fullName: '焦作市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 410900,
    name: '濮阳',
    fullName: '濮阳市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411000,
    name: '许昌',
    fullName: '许昌市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411100,
    name: '漯河',
    fullName: '漯河市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411200,
    name: '三门峡',
    fullName: '三门峡市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411300,
    name: '南阳',
    fullName: '南阳市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411400,
    name: '商丘',
    fullName: '商丘市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411500,
    name: '信阳',
    fullName: '信阳市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411600,
    name: '周口',
    fullName: '周口市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 411700,
    name: '驻马店',
    fullName: '驻马店市',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 419000,
    name: '省直辖县级单位',
    fullName: '省直辖县级行政单位',
    parentId: 410000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420000,
    name: '湖北',
    fullName: '湖北省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 5,
    examAreaId: 0,
  },
  {
    id: 420100,
    name: '武汉',
    fullName: '武汉市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420200,
    name: '黄石',
    fullName: '黄石市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420300,
    name: '十堰',
    fullName: '十堰市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420500,
    name: '宜昌',
    fullName: '宜昌市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420600,
    name: '襄阳',
    fullName: '襄阳市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420700,
    name: '鄂州',
    fullName: '鄂州市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420800,
    name: '荆门',
    fullName: '荆门市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 420900,
    name: '孝感',
    fullName: '孝感市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 421000,
    name: '荆州',
    fullName: '荆州市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 421100,
    name: '黄冈',
    fullName: '黄冈市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 421200,
    name: '咸宁',
    fullName: '咸宁市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 421300,
    name: '随州',
    fullName: '随州市',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 422800,
    name: '恩施',
    fullName: '恩施土家族苗族自治州',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 429000,
    name: '省直辖县级单位',
    fullName: '省直辖县级行政单位',
    parentId: 420000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430000,
    name: '湖南',
    fullName: '湖南省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 6,
    examAreaId: 0,
  },
  {
    id: 430100,
    name: '长沙',
    fullName: '长沙市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430200,
    name: '株洲',
    fullName: '株洲市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430300,
    name: '湘潭',
    fullName: '湘潭市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430400,
    name: '衡阳',
    fullName: '衡阳市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430500,
    name: '邵阳',
    fullName: '邵阳市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430600,
    name: '岳阳',
    fullName: '岳阳市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430700,
    name: '常德',
    fullName: '常德市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430800,
    name: '张家界',
    fullName: '张家界市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 430900,
    name: '益阳',
    fullName: '益阳市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 431000,
    name: '郴州',
    fullName: '郴州市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 431100,
    name: '永州',
    fullName: '永州市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 431200,
    name: '怀化',
    fullName: '怀化市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 431300,
    name: '娄底',
    fullName: '娄底市',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 433100,
    name: '湘西',
    fullName: '湘西土家族苗族自治州',
    parentId: 430000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440000,
    name: '广东',
    fullName: '广东省',
    parentId: 0,
    Classify: 1,
    OrderIndex: 6,
    examAreaId: 0,
  },
  {
    id: 440100,
    name: '广州',
    fullName: '广州市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440200,
    name: '韶关',
    fullName: '韶关市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440300,
    name: '深圳',
    fullName: '深圳市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440400,
    name: '珠海',
    fullName: '珠海市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440500,
    name: '汕头',
    fullName: '汕头市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440600,
    name: '佛山',
    fullName: '佛山市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440700,
    name: '江门',
    fullName: '江门市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440800,
    name: '湛江',
    fullName: '湛江市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 440900,
    name: '茂名',
    fullName: '茂名市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441200,
    name: '肇庆',
    fullName: '肇庆市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441300,
    name: '惠州',
    fullName: '惠州市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441400,
    name: '梅州',
    fullName: '梅州市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441500,
    name: '汕尾',
    fullName: '汕尾市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441600,
    name: '河源',
    fullName: '河源市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441700,
    name: '阳江',
    fullName: '阳江市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441800,
    name: '清远',
    fullName: '清远市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 441900,
    name: '东莞',
    fullName: '东莞市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 442000,
    name: '中山',
    fullName: '中山市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 445100,
    name: '潮州',
    fullName: '潮州市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 445200,
    name: '揭阳',
    fullName: '揭阳市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 445300,
    name: '云浮',
    fullName: '云浮市',
    parentId: 440000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450000,
    name: '广西',
    fullName: '广西壮族自治区',
    parentId: 0,
    Classify: 1,
    OrderIndex: 7,
    examAreaId: 0,
  },
  {
    id: 450100,
    name: '南宁',
    fullName: '南宁市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450200,
    name: '柳州',
    fullName: '柳州市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450300,
    name: '桂林',
    fullName: '桂林市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450400,
    name: '梧州',
    fullName: '梧州市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450500,
    name: '北海',
    fullName: '北海市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450600,
    name: '防城港',
    fullName: '防城港市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450700,
    name: '钦州',
    fullName: '钦州市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450800,
    name: '贵港',
    fullName: '贵港市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 450900,
    name: '玉林',
    fullName: '玉林市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 451000,
    name: '百色',
    fullName: '百色市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 451100,
    name: '贺州',
    fullName: '贺州市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 451200,
    name: '河池',
    fullName: '河池市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 451300,
    name: '来宾',
    fullName: '来宾市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 451400,
    name: '崇左',
    fullName: '崇左市',
    parentId: 450000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 460000,
    name: '海南',
    fullName: '海南省',
    parentId: 0,
    Classify: 2,
    OrderIndex: 1,
    examAreaId: 0,
  },
  {
    id: 460100,
    name: '海口',
    fullName: '海口市',
    parentId: 460000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 460200,
    name: '三亚',
    fullName: '三亚市',
    parentId: 460000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 460300,
    name: '三沙',
    fullName: '三沙市',
    parentId: 460000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 460400,
    name: '儋州',
    fullName: '儋州市',
    parentId: 460000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 469000,
    name: '省直辖县级单位',
    fullName: '省直辖县级行政单位',
    parentId: 460000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500000,
    name: '重庆',
    fullName: '重庆',
    parentId: 0,
    Classify: 1,
    OrderIndex: 3,
    examAreaId: 0,
  },
  {
    id: 500101,
    name: '万州',
    fullName: '万州区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500102,
    name: '涪陵',
    fullName: '涪陵区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500103,
    name: '渝中',
    fullName: '渝中区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500104,
    name: '大渡口',
    fullName: '大渡口区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500105,
    name: '江北',
    fullName: '江北区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500106,
    name: '沙坪坝',
    fullName: '沙坪坝区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500107,
    name: '九龙坡',
    fullName: '九龙坡区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500108,
    name: '南岸',
    fullName: '南岸区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500109,
    name: '北碚',
    fullName: '北碚区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500110,
    name: '綦江',
    fullName: '綦江区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500111,
    name: '大足',
    fullName: '大足区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500112,
    name: '渝北',
    fullName: '渝北区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500113,
    name: '巴南',
    fullName: '巴南区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500114,
    name: '黔江',
    fullName: '黔江区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500115,
    name: '长寿',
    fullName: '长寿区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500116,
    name: '江津',
    fullName: '江津区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500117,
    name: '合川',
    fullName: '合川区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500118,
    name: '永川',
    fullName: '永川区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500119,
    name: '南川',
    fullName: '南川区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500120,
    name: '璧山',
    fullName: '璧山区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500151,
    name: '铜梁',
    fullName: '铜梁区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500152,
    name: '潼南',
    fullName: '潼南区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500153,
    name: '荣昌',
    fullName: '荣昌区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500154,
    name: '开州',
    fullName: '开州区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500155,
    name: '梁平',
    fullName: '梁平区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500156,
    name: '武隆',
    fullName: '武隆区',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500229,
    name: '城口',
    fullName: '城口县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500230,
    name: '丰都',
    fullName: '丰都县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500231,
    name: '垫江',
    fullName: '垫江县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500233,
    name: '忠县',
    fullName: '忠县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500235,
    name: '云阳',
    fullName: '云阳县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500236,
    name: '奉节',
    fullName: '奉节县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500237,
    name: '巫山',
    fullName: '巫山县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500238,
    name: '巫溪',
    fullName: '巫溪县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500240,
    name: '石柱',
    fullName: '石柱土家族自治县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500241,
    name: '秀山',
    fullName: '秀山土家族苗族自治县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500242,
    name: '酉阳',
    fullName: '酉阳土家族苗族自治县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 500243,
    name: '彭水',
    fullName: '彭水苗族土家族自治县',
    parentId: 500000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510000,
    name: '四川',
    fullName: '四川省',
    parentId: 0,
    Classify: 3,
    OrderIndex: 9,
    examAreaId: 0,
  },
  {
    id: 510100,
    name: '成都',
    fullName: '成都市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510300,
    name: '自贡',
    fullName: '自贡市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510400,
    name: '攀枝花',
    fullName: '攀枝花市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510500,
    name: '泸州',
    fullName: '泸州市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510600,
    name: '德阳',
    fullName: '德阳市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510700,
    name: '绵阳',
    fullName: '绵阳市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510800,
    name: '广元',
    fullName: '广元市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 510900,
    name: '遂宁',
    fullName: '遂宁市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511000,
    name: '内江',
    fullName: '内江市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511100,
    name: '乐山',
    fullName: '乐山市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511300,
    name: '南充',
    fullName: '南充市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511400,
    name: '眉山',
    fullName: '眉山市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511500,
    name: '宜宾',
    fullName: '宜宾市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511600,
    name: '广安',
    fullName: '广安市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511700,
    name: '达州',
    fullName: '达州市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511800,
    name: '雅安',
    fullName: '雅安市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 511900,
    name: '巴中',
    fullName: '巴中市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 512000,
    name: '资阳',
    fullName: '资阳市',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 513200,
    name: '阿坝',
    fullName: '阿坝藏族羌族自治州',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 513300,
    name: '甘孜',
    fullName: '甘孜藏族自治州',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 513400,
    name: '凉山',
    fullName: '凉山彝族自治州',
    parentId: 510000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 520000,
    name: '贵州',
    fullName: '贵州省',
    parentId: 0,
    Classify: 1,
    OrderIndex: 8,
    examAreaId: 0,
  },
  {
    id: 520100,
    name: '贵阳',
    fullName: '贵阳市',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 520200,
    name: '六盘水',
    fullName: '六盘水市',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 520300,
    name: '遵义',
    fullName: '遵义市',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 520400,
    name: '安顺',
    fullName: '安顺市',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 520500,
    name: '毕节',
    fullName: '毕节市',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 520600,
    name: '铜仁',
    fullName: '铜仁市',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 522300,
    name: '黔西',
    fullName: '黔西南布依族苗族自治州',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 522600,
    name: '黔东南',
    fullName: '黔东南苗族侗族自治州',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 522700,
    name: '黔南',
    fullName: '黔南布依族苗族自治州',
    parentId: 520000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530000,
    name: '云南',
    fullName: '云南省',
    parentId: 0,
    Classify: 4,
    OrderIndex: 4,
    examAreaId: 0,
  },
  {
    id: 530100,
    name: '昆明',
    fullName: '昆明市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530300,
    name: '曲靖',
    fullName: '曲靖市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530400,
    name: '玉溪',
    fullName: '玉溪市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530500,
    name: '保山',
    fullName: '保山市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530600,
    name: '昭通',
    fullName: '昭通市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530700,
    name: '丽江',
    fullName: '丽江市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530800,
    name: '普洱',
    fullName: '普洱市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 530900,
    name: '临沧',
    fullName: '临沧市',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 532300,
    name: '楚雄',
    fullName: '楚雄彝族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 532500,
    name: '红河',
    fullName: '红河哈尼族彝族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 532600,
    name: '文山',
    fullName: '文山壮族苗族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 532800,
    name: '西双版纳',
    fullName: '西双版纳傣族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 532900,
    name: '大理',
    fullName: '大理白族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 533100,
    name: '德宏',
    fullName: '德宏傣族景颇族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 533300,
    name: '怒江',
    fullName: '怒江傈僳族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 533400,
    name: '迪庆',
    fullName: '迪庆藏族自治州',
    parentId: 530000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 540000,
    name: '西藏',
    fullName: '西藏自治区',
    parentId: 0,
    Classify: 4,
    OrderIndex: 2,
    examAreaId: 0,
  },
  {
    id: 540100,
    name: '拉萨',
    fullName: '拉萨市',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 540200,
    name: '日喀则',
    fullName: '日喀则市',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 540300,
    name: '昌都',
    fullName: '昌都市',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 540400,
    name: '林芝',
    fullName: '林芝市',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 540500,
    name: '山南',
    fullName: '山南市',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 540600,
    name: '那曲',
    fullName: '那曲市',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 542500,
    name: '阿里',
    fullName: '阿里地区',
    parentId: 540000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610000,
    name: '陕西',
    fullName: '陕西省',
    parentId: 0,
    Classify: 3,
    OrderIndex: 7,
    examAreaId: 0,
  },
  {
    id: 610100,
    name: '西安',
    fullName: '西安市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610200,
    name: '铜川',
    fullName: '铜川市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610300,
    name: '宝鸡',
    fullName: '宝鸡市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610400,
    name: '咸阳',
    fullName: '咸阳市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610500,
    name: '渭南',
    fullName: '渭南市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610600,
    name: '延安',
    fullName: '延安市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610700,
    name: '汉中',
    fullName: '汉中市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610800,
    name: '榆林',
    fullName: '榆林市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 610900,
    name: '安康',
    fullName: '安康市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 611000,
    name: '商洛',
    fullName: '商洛市',
    parentId: 610000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620000,
    name: '甘肃',
    fullName: '甘肃省',
    parentId: 0,
    Classify: 1,
    OrderIndex: 5,
    examAreaId: 0,
  },
  {
    id: 620100,
    name: '兰州',
    fullName: '兰州市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620200,
    name: '嘉峪关',
    fullName: '嘉峪关市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620300,
    name: '金昌',
    fullName: '金昌市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620400,
    name: '白银',
    fullName: '白银市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620500,
    name: '天水',
    fullName: '天水市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620600,
    name: '武威',
    fullName: '武威市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620700,
    name: '张掖',
    fullName: '张掖市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620800,
    name: '平凉',
    fullName: '平凉市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 620900,
    name: '酒泉',
    fullName: '酒泉市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 621000,
    name: '庆阳',
    fullName: '庆阳市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 621100,
    name: '定西',
    fullName: '定西市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 621200,
    name: '陇南',
    fullName: '陇南市',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 622900,
    name: '临夏',
    fullName: '临夏回族自治州',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 623000,
    name: '甘南',
    fullName: '甘南藏族自治州',
    parentId: 620000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 630000,
    name: '青海',
    fullName: '青海省',
    parentId: 0,
    Classify: 3,
    OrderIndex: 4,
    examAreaId: 0,
  },
  {
    id: 630100,
    name: '西宁',
    fullName: '西宁市',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 630200,
    name: '海东',
    fullName: '海东市',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 632200,
    name: '海北',
    fullName: '海北藏族自治州',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 632300,
    name: '黄南',
    fullName: '黄南藏族自治州',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 632500,
    name: '海南',
    fullName: '海南藏族自治州',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 632600,
    name: '果洛',
    fullName: '果洛藏族自治州',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 632700,
    name: '玉树',
    fullName: '玉树藏族自治州',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 632800,
    name: '海西',
    fullName: '海西蒙古族藏族自治州',
    parentId: 630000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 640000,
    name: '宁夏',
    fullName: '宁夏回族自治区',
    parentId: 0,
    Classify: 3,
    OrderIndex: 3,
    examAreaId: 0,
  },
  {
    id: 640100,
    name: '银川',
    fullName: '银川市',
    parentId: 640000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 640200,
    name: '石嘴山',
    fullName: '石嘴山市',
    parentId: 640000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 640300,
    name: '吴忠',
    fullName: '吴忠市',
    parentId: 640000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 640400,
    name: '固原',
    fullName: '固原市',
    parentId: 640000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 640500,
    name: '中卫',
    fullName: '中卫市',
    parentId: 640000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 650000,
    name: '新疆',
    fullName: '新疆维吾尔自治区',
    parentId: 0,
    Classify: 4,
    OrderIndex: 3,
    examAreaId: 0,
  },
  {
    id: 650100,
    name: '乌鲁木齐',
    fullName: '乌鲁木齐市',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 650200,
    name: '克拉玛依',
    fullName: '克拉玛依市',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 650400,
    name: '吐鲁番',
    fullName: '吐鲁番市',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 650500,
    name: '哈密',
    fullName: '哈密市',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 652300,
    name: '昌吉',
    fullName: '昌吉回族自治州',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 652700,
    name: '博尔塔拉',
    fullName: '博尔塔拉蒙古自治州',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 652800,
    name: '巴音郭楞',
    fullName: '巴音郭楞蒙古自治州',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 652900,
    name: '阿克苏',
    fullName: '阿克苏地区',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 653000,
    name: '克孜勒苏',
    fullName: '克孜勒苏柯尔克孜自治州',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 653100,
    name: '喀什',
    fullName: '喀什地区',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 653200,
    name: '和田',
    fullName: '和田地区',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 654000,
    name: '伊犁',
    fullName: '伊犁哈萨克自治州',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 654200,
    name: '塔城',
    fullName: '塔城地区',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 654300,
    name: '阿勒泰',
    fullName: '阿勒泰地区',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 659000,
    name: '省直辖县级单位',
    fullName: '省直辖县级行政单位',
    parentId: 650000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710000,
    name: '台湾',
    fullName: '台湾',
    parentId: 0,
    Classify: 5,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710100,
    name: '台北',
    fullName: '台北市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710200,
    name: '高雄',
    fullName: '高雄市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710300,
    name: '台南',
    fullName: '台南市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710400,
    name: '台中',
    fullName: '台中市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710500,
    name: '金门',
    fullName: '金门县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710600,
    name: '南投',
    fullName: '南投县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710700,
    name: '基隆',
    fullName: '基隆市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710800,
    name: '新竹',
    fullName: '新竹市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 710900,
    name: '嘉义',
    fullName: '嘉义市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711100,
    name: '新北',
    fullName: '新北市',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711200,
    name: '宜兰',
    fullName: '宜兰县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711300,
    name: '新竹',
    fullName: '新竹县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711400,
    name: '桃园',
    fullName: '桃园县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711500,
    name: '苗栗',
    fullName: '苗栗县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711700,
    name: '彰化',
    fullName: '彰化县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 711900,
    name: '嘉义',
    fullName: '嘉义县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 712100,
    name: '云林',
    fullName: '云林县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 712400,
    name: '屏东',
    fullName: '屏东县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 712500,
    name: '台东',
    fullName: '台东县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 712600,
    name: '花莲',
    fullName: '花莲县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 712700,
    name: '澎湖',
    fullName: '澎湖县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 712800,
    name: '连江',
    fullName: '连江县',
    parentId: 710000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 810000,
    name: '香港',
    fullName: '香港特别行政区',
    parentId: 0,
    Classify: 5,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 810100,
    name: '香港岛',
    fullName: '香港岛',
    parentId: 810000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 810200,
    name: '九龙',
    fullName: '九龙',
    parentId: 810000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 810300,
    name: '新界',
    fullName: '新界',
    parentId: 810000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 820000,
    name: '澳门',
    fullName: '澳门特别行政区',
    parentId: 0,
    Classify: 5,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 820100,
    name: '澳门半岛',
    fullName: '澳门半岛',
    parentId: 820000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
  {
    id: 820200,
    name: '离岛',
    fullName: '离岛',
    parentId: 820000,
    Classify: 0,
    OrderIndex: 0,
    examAreaId: 0,
  },
];
